<template>
    <div class="main-container">
      <breadcrumb :list="breadcrumbList" />
      <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    
    <tl-header type="h1">
      <div class="main-header margintop-20">Map Perquisites to Employees</div>
    </tl-header>
    <div class="download-content">
      <div class="download-btn">
        <!-- <download-button
          onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-+One+time+payment+and+deduction.xlsx'"
        ></download-button> -->
          <download-button class="downloadTemplateButton" @downloadTemplate="getPerquisiteTemplate"></download-button>    
      </div>
      <div class="margintop-20 margin-bottom-50" :key="componentKey">
        <!-- <upload-file @uploadTemplate="onUploadTemplate($event)" /> -->
        <!-- <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" /> -->
        <upload :tobucket="false" ref="bulkFile" @change="onUploadTemplate($event)"></upload>
      </div>
    </div>

    <pop-up-message
      v-if="showSuccessBulkUploadMsg"
      :message="responseMsg"
      btnText="Back To Perquisites"
      @back="backToUploadPage()"
    ></pop-up-message>
      
  
    </div>
  </template>
  
  
  <script>
import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    props: {},
    components: {},
    data() {
      return {
        navList:[],
        breadcrumbList:[
                {
                  name: "Payroll",
                  url: `/dashboard/${this.$route.params.entity_index}/payroll`
                },
                {
                  name: "Perquisites",
                  url: `/dashboard/${this.$route.params.entity_index}/payroll/perquisites`
                }
          ],
        toast: false,
        errmsg: "",
        showSuccessBulkUploadMsg: false,
        responseMsg: "",
      };
    },

    mounted(){

    },

    activated(){

    },

    computed: {
      ...mapState({
        payrollMonth: state => state.payroll.runpayroll.payrollMonth,
        payrollYear: state => state.payroll.runpayroll.payrollYear
      }),
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),

      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      },

      orgId() {
        return this.$store.getters["onboard/getOrgId"];
      }
    },

    methods: {
      ...mapActions({
        act_get_template: "onboard/perquisites/getPerquisiteTemplate",
        act_upload_template: "onboard/perquisites/uploadPerquisiteTemplate"
      }),

      async getPerquisiteTemplate() {
        try {
          let data = {
            le_id: this.le_id,
            financial_year: this.payrollYear,
            month: this.payrollMonth
          }
          let res = await this.act_get_template(data);
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },

      async onUploadTemplate(event) {
        let formData = new FormData();
        formData.append("file", event);
        formData.append("le_id", this.le_id);
        try {
          let res = await this.act_upload_template(formData);
          if (res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.$refs.bulkFile.uploaded = true;
            this.$refs.bulkFile.uploading = false;
            this.showSuccessBulkUploadMsg = true;
          }
          setTimeout(() => {
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      },

      backToUploadPage() {
      this.showSuccessMsg = false;
      this.showSuccessBulkUploadMsg = false;
      },
    }
  };
  </script>
  <style lang="scss" scoped>
  @import "@/scss/components/margins.scss";  //margins

  .download-content{
    margin-top: 20px;
  }
  </style>
  